import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translations } from "./translations";
import { taloLegal } from "./legalTalo";
import { wapiLegal } from "./legalWapi";

const LanguageContext = createContext(null);

const STORAGE_KEY = "talo-lang";

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    return saved === "en" ? "en" : "fr";
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const value = useMemo(
    () => ({
      lang,
      setLang,
      t: {
        ...translations[lang],
        taloLegal: taloLegal[lang],
        wapiLegal: wapiLegal[lang],
      },
    }),
    [lang]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
}
